import { TableRowSelection } from 'antd/lib/table/interface';
import { t } from 'i18next';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { LocationState } from 'types';

import { DocumentModel, DOCUMENT_TYPE } from 'api/documents/documents.model';
import { TabItem, TabMenu } from 'components/TabMenu';
import { TablePage } from 'components/TablePage';
import { useAuthenticatedContext } from 'hooks/useAuthenticated';
import { useCertificatesQuery } from 'hooks/useCertificatesQuery';
import { CertificateDetailsModel } from 'models/certificate.model';

import { CertificatesPageTabsEnum } from '../../constants';
import CertificatesFilters from './CertificatesFilters';
import CertificatesList from './CertificatesList';
import Drafts from './Drafts';
import useConfig from './useConfig';

type CertifacatePageProps = {
  rowSelection?: TableRowSelection<DocumentModel<CertificateDetailsModel>>;
};

const CertificatesPage = ({ rowSelection }: CertifacatePageProps) => {
  const { state } = useLocation();
  const { currentUser } = useAuthenticatedContext();
  const { categoriesByTabs } = useConfig();
  const tabs = Object.keys(categoriesByTabs);

  const [selectedTab, setSelectedTab] = useState<string>(
    (state as LocationState)?.selectedTab || tabs[0]
  );

  return (
    <>
      <TabMenu selectedKeys={[selectedTab]}>
        {tabs.map((tab) => (
          <TabItem onClick={() => setSelectedTab(tab)} key={tab}>
            {t(`certificates.${tab}`)}
          </TabItem>
        ))}
      </TabMenu>
      {!rowSelection && selectedTab === CertificatesPageTabsEnum.MY_CERTIFICATES && <Drafts />}
      <TablePage<DocumentModel<CertificateDetailsModel>>
        request={useCertificatesQuery}
        filtersComponent={CertificatesFilters}
        tableComponent={CertificatesList}
        tableProps={{ selectedTab, rowSelection }}
        filtersProps={{ categories: categoriesByTabs[selectedTab] }}
        defaultParams={{
          documentType: DOCUMENT_TYPE.PUBLIC,
          draft: false,
          ...(selectedTab === CertificatesPageTabsEnum.MY_CERTIFICATES && {
            senderPublisherId: currentUser?.publisherId,
            creationDateRange: {
              from: '2023-11-23T00:00:00Z', // this is the hack to hide previous certs which should not be available now for given user's company
            },
          }),
          ...(selectedTab === CertificatesPageTabsEnum.FAVOURITE_CERTIFICATES && {
            favourite: true,
          }),
        }}
      />
    </>
  );
};

export default CertificatesPage;
